module.exports = __webpack_public_path__ + "vrsnl-app-icon.56b308f67766ad48fee991e1503f0930.png";